function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.9983 0.000488281H0V60H89.9983V0.000488281Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M50.624 0H39.3742V24.3744H0V35.6242H39.3742V59.9986H50.624V35.6242H89.9983V24.3744H50.624V0Z",
  fill: "#D80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2188 40.4336L89.9983 51.978V40.4336H69.2188Z",
  fill: "#0052B4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7817 40.4336L89.9985 59.9984V54.4659L64.7404 40.4336H54.7817Z",
  fill: "#0052B4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6179 59.9983L54.7817 45.6436V59.9983H80.6179Z",
  fill: "#0052B4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7817 40.4336L89.9985 59.9984V54.4659L64.7404 40.4336H54.7817Z",
  fill: "#F0F0F0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7817 40.4336L89.9985 59.9984V54.4659L64.7404 40.4336H54.7817Z",
  fill: "#D80027"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8799 40.4336L0 49.2559V40.4336H15.8799Z",
  fill: "#0052B4"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2165 42.9219V59.9989H4.48047L35.2165 42.9219Z",
  fill: "#0052B4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.258 40.4336L0 54.4659V59.9984L35.2167 40.4336H25.258Z",
  fill: "#D80027"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7796 19.5649L0 8.02051V19.5649H20.7796Z",
  fill: "#0052B4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2167 19.5648L0 0V5.53243L25.258 19.5648H35.2167Z",
  fill: "#0052B4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M9.38086 0L35.217 14.3547V0H9.38086Z",
  fill: "#0052B4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2167 19.5648L0 0V5.53243L25.258 19.5648H35.2167Z",
  fill: "#F0F0F0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2167 19.5648L0 0V5.53243L25.258 19.5648H35.2167Z",
  fill: "#D80027"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1187 19.565L89.9986 10.7427V19.565H74.1187Z",
  fill: "#0052B4"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M54.7817 17.077V0H85.5177L54.7817 17.077Z",
  fill: "#0052B4"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7404 19.5648L89.9985 5.53243V0L54.7817 19.5648H64.7404Z",
  fill: "#D80027"
});

var SvgGbp = function SvgGbp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGbp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GBP.b42fef38.svg";
export { ForwardRef as ReactComponent };